import { Trans } from '@lingui/react/macro'
import { Box } from 'designSystem/components/Box'
import { Button } from 'designSystem/components/Button'
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from 'designSystem/components/HoverCard'
import { Text } from 'designSystem/components/Text'
import type { InspectionAnalysisCitation } from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/documentSearchApiSchemas'
import {
  inspectionAnalysisCitationLabel,
  inspectionTminMethodLabel,
} from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionAnalysisCitations'
import { ScanLine } from 'lucide-react'
import React from 'react'

/** The inspection analysis that a statement's values come from. Not clickable yet. */
export function ResponseSegmentInspectionChip({
  citation,
  onCitationHoverChange,
}: {
  citation: InspectionAnalysisCitation
  onCitationHoverChange?: (highlighted: boolean) => void
}): React.ReactElement {
  const label = inspectionAnalysisCitationLabel(citation)
  const tminMethod = inspectionTminMethodLabel(citation.tmin_method)
  const name = [citation.asset, citation.component]
    .filter((part): part is string => Boolean(part))
    .join(' · ')
  const date = citation.inspection_date
  const state = citation.data_state
  return (
    <HoverCard onOpenChange={onCitationHoverChange}>
      <HoverCardTrigger asChild>
        <Button type='button' variant='outline' size='xs'>
          <ScanLine />
          {label}
        </Button>
      </HoverCardTrigger>
      <HoverCardContent side='bottom'>
        <Box display='flex' direction='column' gap='xs'>
          {name ? (
            <Text variant='caption' weight='medium'>
              {name}
            </Text>
          ) : null}
          {date ? (
            <Text variant='caption'>
              {state ? (
                <Trans>
                  Inspection of {date} · {state}
                </Trans>
              ) : (
                <Trans>Inspection of {date}</Trans>
              )}
            </Text>
          ) : null}
          {tminMethod ? (
            <Text variant='caption'>
              <Trans>t-min: {tminMethod}</Trans>
            </Text>
          ) : null}
          <Text variant='caption' color='muted'>
            <Trans>From the inspection analysis of this component.</Trans>
          </Text>
        </Box>
      </HoverCardContent>
    </HoverCard>
  )
}
